const updateCartCount = (count) => {
  if (!Sq.PublicWebNav) return;
  Object.prototype.hasOwnProperty.call(Sq.PublicWebNav, 'setCartCount')
    ? Sq.PublicWebNav.setCartCount(count)
    : (Sq.PublicWebNav.cartCount = count);
};

const updateCtaSubnav = (ctaSubnavJSON) => {
  if (!Sq.PublicWebNav) return;
  Object.prototype.hasOwnProperty.call(Sq.PublicWebNav, 'setCtaSubnavJSON')
    ? Sq.PublicWebNav.setCtaSubnavJSON(ctaSubnavJSON)
    : (Sq.PublicWebNav.ctaSubnavJSON = ctaSubnavJSON);
};

const updateCurrentUrl = (url) => {
  if (!Sq.PublicWebNav) return;
  Object.prototype.hasOwnProperty.call(Sq.PublicWebNav, 'setCurrentUrl')
    ? Sq.PublicWebNav.setCurrentUrl(url)
    : (Sq.PublicWebNav.currentUrl = url);
};

export { updateCartCount, updateCtaSubnav, updateCurrentUrl };
